import React from 'react'
import './CreateAsset.css'

function CreateAsset() {
    return (
        <>
            <form action="" className="formControll">
            <h2 className="formSectioTitle">Create collectible</h2>
                <div className="formSubAre">
                    <label htmlFor="">Title</label> <br />
                    <input type="text" />
                </div>
                <div className="formSubAre">
                    <label htmlFor="">What kind of item are you making?</label> <br />
                    <select name="" id="">
                        <option value="">Art</option>
                        <option value="">Collectible</option>
                        <option value="">Game Items</option>
                        <option value="">Music</option>
                        <option value="">Domains</option>
                        <option value="">Templates</option>
                        <option value="">Video</option>
                    </select>
                </div>
                <div className="formSubAre">
                    <label htmlFor="">Description</label> <br />
                    <textarea name="" id="" cols="30" rows="10"></textarea>
                </div>
                <div className="formSubAre">
                    <label htmlFor="">Upload file: images, videos, gifs</label> <br />
                    <input type="file" accept="image/*,video/*, .glb" />
                </div>
                <div className="formSubAre">
                    <label htmlFor="">Fixed Price - in ETH</label> <br />
                    <input step="0.0001" type="number" />
                </div>
                <button className="AssetsActionBtn btnCreateNew">Create New</button>
            </form>
        </>
    )
}

export default CreateAsset
